import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }

import QRCodeStyling from "./core/QRCodeStyling";

export interface Props {
  value: string;
  width?: number;
  height?: number;
  margin?: number;
  imgclass?: string;
  myclass?: string;
  downloadButton?: string;
  buttonName?: string;
  qrOptions?: any;
  imageOptions?: any;
  dotsOptions?: any;
  backgroundOptions?: any;
  cornersSquareOptions?: any;
  cornersDotOptions?: any;
  fileExt?: string;
  image?: string;
  download?: boolean;
  downloadOptions?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCodeVue3Async',
  props: {
    value: { default: "" },
    width: { default: 300 },
    height: { default: 300 },
    margin: { default: 0 },
    imgclass: { default: "" },
    myclass: { default: "" },
    downloadButton: { default: "" },
    buttonName: { default: "Download" },
    qrOptions: { default: {
    typeNumber: 0,
    mode: "Byte",
    errorCorrectionLevel: "Q"
  } },
    imageOptions: { default: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 } },
    dotsOptions: { default: {
    type: "dots",
    color: "#6a1a4c",
    gradient: {
      type: "linear",
      rotation: 0,
      colorStops: [
        { offset: 0, color: "#6a1a4c" },
        { offset: 1, color: "#6a1a4c" }
      ]
    }
  } },
    backgroundOptions: { default: { color: "#ffffff" } },
    cornersSquareOptions: { default: { type: "dot", color: "#000000" } },
    cornersDotOptions: { default: { type: undefined, color: "#000000" } },
    fileExt: { default: "png" },
    image: { default: "" },
    download: { type: Boolean, default: false },
    downloadOptions: { default: { name: "vqr", extension: "png" } }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

//import { computed, reactive, ref, watch } from "vue";
const props = __props;

const qrCode = new QRCodeStyling({
  data: props.value,
  width: props.width,
  height: props.height,
  margin: props.margin,
  qrOptions: props.qrOptions,
  imageOptions: props.imageOptions,
  dotsOptions: props.dotsOptions,
  backgroundOptions: props.backgroundOptions,
  image: props.image,
  cornersSquareOptions: props.cornersSquareOptions,
  cornersDotOptions: props.cornersDotOptions
});

let imageUrl = (
  ([__temp,__restore] = _withAsyncContext(() => qrCode.getImageUrl(props.fileExt))),
  __temp = await __temp,
  __restore(),
  __temp
);

function onDownloadClick() {
  qrCode.download(props.downloadOptions);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(imageUrl))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.myclass)
        }, [
          _createElementVNode("img", {
            src: _unref(imageUrl),
            class: _normalizeClass(_ctx.imgclass),
            crossorigin: "anonymous"
          }, null, 10, _hoisted_1)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(imageUrl) && _ctx.download)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: onDownloadClick,
            class: _normalizeClass(_ctx.downloadButton)
          }, _toDisplayString(_ctx.buttonName), 3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})